import { useAppDispatch } from 'client/hooks/use-dispatch'

export function useUpdateStoreObject<
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  Object extends Record<string, any> | null,
  ActionType,
>(
  action: (payload: Object) => {
    type: ActionType
    payload: Object
  },
) {
  const dispatch = useAppDispatch()
  return (newObject: Object) => {
    dispatch(action(newObject))
  }
}

export function useUpdateStoreObjectProp<
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  Object extends Record<string, any> | null,
  ActionType,
>(
  object: Object,
  action: (payload: Object) => {
    type: ActionType
    payload: Object
  },
) {
  const dispatch = useAppDispatch()
  return <Key extends keyof Object>(prop: Key) => {
    return (value: Object[Key]) => {
      dispatch(
        action({
          ...object,
          [prop]: value,
        }),
      )
    }
  }
}
